/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { Alert, Grid, useMediaQuery } from '@mui/material';
import NewModal from '../NewModal';

import {
  REPEAT_OPTION_WEEKLY,
  CAL_REGISTER_FIELD_GROUP_TOGGLE,
  CAL_REGISTER_FIELD_WEEK,
  CAL_REGISTER_FIELD_REPEAT,
  CAL_REGISTER_FIELD_TIMES,
  CAL_REGISTER_FIELD_TITLE,
  CAL_REGISTER_FIELD_DATE,
  CAL_REGISTER_FIELD_TIME,
  CAL_REGISTER_FIELD_CMD_TOGGLE,
  CAL_REGISTER_FIELD_MONTHLY_DATEPICKER,
  CAL_REGISTER_FIELD_YEARLY_DATEPICKER,
  CAL_REGISTER_FIELD_CMD,
  MODAL_TYPE_CALENDAR_UPDATE,
  MODAL_TYPE_CALENDAR_DELETE,
  REGISTER_TOGGLE_GROUP_SELECT,
} from '../../common/consts';
import CalendarUpdateItem from './CalendarUpdateItem';
import { getManagerMode, getManagerRobotId } from '../../common/util';

const CalendarItemModal = ({
  type: itemType,
  open,
  items: { list, cmds, groupLists },
  onUpdate,
  onCancel,
}) => {
  const [itemList, setItemList] = useState([]);
  const matches = useMediaQuery('(max-width:600px)');
  const bManageMode = getManagerMode();

  useEffect(() => {
    const newList = list.map(
      ({ execTime: et, repeatValue, repeat, group: gr, ...rest }) => {
        const execTime = moment(et);
        const defaultDate = moment().set({
          year: execTime.get('year'),
          month: repeatValue.month,
          date: repeatValue.date,
        });
        const group = { ...gr };
        group.list = bManageMode
          ? [{ robotId: getManagerRobotId() }]
          : gr.list.map((gId) => {
              const { name } = groupLists.find(
                ({ id: groupId }) => groupId === gId,
              );
              return { id: gId, name };
            });
        return {
          repeatValue,
          execTime,
          defaultDate,
          repeat,
          checked: true,
          group,
          ...rest,
        };
      },
    );
    setItemList(newList);
  }, [list, groupLists]);

  const handleInputChange = (e) => {
    if (itemType === MODAL_TYPE_CALENDAR_DELETE) return;
    const {
      target: { name, value },
    } = e;
    const index = parseInt(name.slice(name.length - 1, name.length), 10);
    const newList = [...itemList];
    let newItem = { ...newList[index] };

    if (name.includes(CAL_REGISTER_FIELD_TITLE)) {
      newItem = { ...newItem, title: value };
    } else if (name.includes(CAL_REGISTER_FIELD_DATE)) {
      const [year, month, date] = value.split('-');
      const execTime = newItem.execTime.set({
        year,
        month: Number(month) - 1,
        date,
      });
      newItem = { ...newItem, execTime };
    } else if (name.includes(CAL_REGISTER_FIELD_TIMES)) {
      newItem = {
        ...newItem,
        repeatValue: {
          ...newItem.repeatValue,
          value: { ...newItem.repeatValue.value, times: value },
        },
      };
    } else if (name.includes(CAL_REGISTER_FIELD_REPEAT)) {
      newItem = {
        ...newItem,
        repeatValue: { ...newItem.repeatValue, type: value },
      };
      if (value !== REPEAT_OPTION_WEEKLY) {
        newItem = {
          ...newItem,
          repeatValue: {
            ...newItem.repeatValue,
            value: {
              ...newItem.repeatValue.value,
              day: [],
            },
          },
        };
      }
    } else if (name.includes('month')) {
      const defaultDate = moment().set({
        year: newItem.execTime.get('year'),
        month: value,
        date: newItem.execTime.get('date'),
      });
      newItem = {
        ...newItem,
        defaultDate,
        repeatValue: {
          ...newItem.repeatValue,
          value: { ...newItem.repeatValue.value, month: value },
        },
      };
    } else if (name.includes(CAL_REGISTER_FIELD_WEEK)) {
      // const i = parseInt(value, 10);
      newItem = {
        ...newItem,
        repeatValue: {
          ...newItem.repeatValue,
          value: {
            ...newItem.repeatValue.value,
            day: value,
          },
        },
      };
      // newItem.repeatValue.value.day[i] = !newItem.repeatValue.value.day[i];
    } else if (name.includes(CAL_REGISTER_FIELD_MONTHLY_DATEPICKER)) {
      const defaultDate = moment().set({
        year: newItem.execTime.get('year'),
        month: newItem.repeatValue.value.month,
        date: value,
      });
      newItem = {
        ...newItem,
        defaultDate,
        repeatValue: {
          ...newItem.repeatValue,
          value: { ...newItem.repeatValue.value, date: value },
        },
      };
    } else if (name.includes(CAL_REGISTER_FIELD_YEARLY_DATEPICKER)) {
      const defaultDate = moment().set({
        year: newItem.execTime.get('year'),
        month: newItem.execTime.get('month'),
        date: value,
      });
      newItem = {
        ...newItem,
        defaultDate,
        repeatValue: {
          ...newItem.repeatValue,
          value: { ...newItem.repeatValue.value, date: value },
        },
      };
    } else if (name.includes(CAL_REGISTER_FIELD_TIME) && value) {
      newItem = {
        ...newItem,
        execTime: newItem.execTime
          .set('hour', value.split(':')[0])
          .set('minute', value.split(':')[1])
          .set('second', 0),
      };
    } else if (
      name.includes(
        `${CAL_REGISTER_FIELD_CMD}-${CAL_REGISTER_FIELD_CMD_TOGGLE}`,
      )
    ) {
      const [bot, command] = value.split('_');
      newItem = { ...newItem, bot, command };
    } else if (name.includes(CAL_REGISTER_FIELD_CMD_TOGGLE)) {
      newItem = { ...newItem, bot: '', command: !newItem.command };
    } else if (name.includes(CAL_REGISTER_FIELD_GROUP_TOGGLE)) {
      newItem = { ...newItem, group: { type: value, list: [] } };
    } else if (name.includes(REGISTER_TOGGLE_GROUP_SELECT)) {
      newItem = { ...newItem, group: { ...newItem.group, list: value } };
    }
    newList[index] = newItem;
    setItemList(newList);
  };

  const handleCheckChange = (e, i) => {
    itemList[i].checked = e.target.checked;
    setItemList([...itemList]);
  };

  const handleUpdateClick = () => {
    onUpdate(itemList);
  };

  const updateButtons = () => {
    if (itemType === MODAL_TYPE_CALENDAR_UPDATE) {
      return [
        { label: '취소', onClick: onCancel },
        {
          label: '선택 수정',
          onClick: handleUpdateClick,
        },
      ];
    }
    return [
      { label: '취소', onClick: onCancel },
      {
        label: '선택 삭제',
        color: 'error',
        onClick: handleUpdateClick,
      },
    ];
  };

  return (
    <NewModal
      open={open}
      buttons={updateButtons()}
      onClose={onCancel}
      // fullWidth
    >
      <Grid
        container
        spacing={2}
        sx={{ width: matches ? '100%' : '600px', overflow: 'scroll' }}
      >
        {!bManageMode && (
          <Grid item xs={12}>
            <Alert type="warning">
              {itemType === MODAL_TYPE_CALENDAR_UPDATE &&
                '일정의 수정 사항은 해당 일정이 등록된 모든 로봇 및 그룹에 일괄 적용됩니다.'}
              {itemType === MODAL_TYPE_CALENDAR_DELETE &&
                '일정 삭제 시, 해당 일정이 등록된 모든 로봇 및 그룹에서 일괄 삭제됩니다.'}
            </Alert>
          </Grid>
        )}
        {itemList &&
          itemList.map(
            (
              {
                _id: key,
                checked,
                command,
                execTime,
                title,
                repeatValue,
                group,
                defaultDate,
              },
              index,
            ) => {
              return (
                <Grid item xs={12} key={key}>
                  <CalendarUpdateItem
                    {...{
                      bManageMode,
                      readOnly: itemType !== MODAL_TYPE_CALENDAR_UPDATE,
                      checked,
                      command,
                      execTime,
                      title,
                      repeatValue,
                      group,
                      groupLists,
                      defaultDate,
                      index,
                      cmds,
                      handleInputChange,
                      handleCheckChange: (e) => handleCheckChange(e, index),
                    }}
                  />
                </Grid>
              );
            },
          )}
      </Grid>
    </NewModal>
  );
};

export default CalendarItemModal;
